import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { stepsPrefixCls } from "@/base/components/steps/Steps.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Steps">> = ({
  iconFinishColor,
  colorSplit,
  colorText,
  colorTextDescription,
  titleFontWeight,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${stepsPrefixCls}`]: {
      [`.${stepsPrefixCls}-item`]: {
        [`&.${stepsPrefixCls}-item-finish`]: {
          [`.${stepsPrefixCls}-item-container > .${stepsPrefixCls}-item-tail::after`]:
            {
              backgroundColor: colorSplit,
            },
          [`.${stepsPrefixCls}-item-icon`]: {
            [`& > .${stepsPrefixCls}-icon`]: {
              color: iconFinishColor,
            },
          },
        },
        [`& > .${stepsPrefixCls}-item-container`]: {
          [`& > .${stepsPrefixCls}-item-content`]: {
            [`& > .${stepsPrefixCls}-item-title`]: {
              fontWeight: titleFontWeight,
              color: colorText,
            },
            [`& > .${stepsPrefixCls}-item-description`]: {
              color: colorTextDescription,
            },
          },
        },
      },
    },
  },
});

export const useStepsStyle = genComponentStyleHook(
  ["Steps", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
